<template>
  <v-container fill-height>
    <v-layout row wrap align-center>
      <v-flex class="text-center">
        <v-icon size="125" color="red">
          mdi-alert-circle
        </v-icon>
        <p class="text-h3"> {{ getLabel('error_occurred') }}</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { getLabel } from '@/utils/index';

export default {

  setup () {
    return { getLabel };
  }
};

</script>
